import { useEffect, useState } from 'react';
import { AutoComplete, AutoCompleteProps, SelectProps } from 'antd';
import classNames from 'classnames';

import MaterialCodeDropdownItem from './components/MaterialCodeDropdownItem/MaterialCodeDropdownItem';
import DropdownItem from './components/DropdownItem';
import styles from './auto-complete.module.css';
import NotFoundContent from './components/NotFoundContent/NotFoundContent';

interface MAutoCompleteProps extends AutoCompleteProps {
  className?: string;
  dropdownItem?: 'MR' | 'ESS';
  showNotFoundContent?: boolean;
}

const MAutoComplete: React.FC<MAutoCompleteProps> = (props) => {
  const [mappedOptions, setOptions] = useState<SelectProps<object>['options']>(
    []
  );

  const { options, className, dropdownItem, notFoundContent, ...restProps } =
    props;

  useEffect(() => {
    const transformedOptions = options?.map((option) => ({
      label:
        dropdownItem === 'MR' ? (
          <MaterialCodeDropdownItem label={option.label} />
        ) : (
          <DropdownItem label={option.label} />
        ),
      value: option.value,
      key: `${option?.label}~${option?.value}`,
    }));
    setOptions(transformedOptions);
  }, [options]);

  return (
    <AutoComplete
      className={classNames(styles.wrapper, className)}
      notFoundContent={notFoundContent || <NotFoundContent />}
      {...restProps}
      options={mappedOptions}
    />
  );
};

export default MAutoComplete;
